import './style.scss';
import { Backdrop, Box, Grid, IconButton } from "@mui/material";
import { useMemo } from "react";
import { ActionButton } from "../../Button";
import { useLanguageContext } from "../../../contexts/LanguageContext";
import DefaultConstants from "../../../data/Constants";
import Dialog, { IDefaultDialogProps } from "../../Dialog";
import AttachmentCard from '../../AttachmentCard';
import Empty from "../../Empty";
import { Close } from "@mui/icons-material";
import Slider from "../../Slider";
import useBackdrop from "../../../hooks/useBackdrop";
import useState from "../../../hooks/useState";
import FileHelper from '../../../helpers/FileHelper';


interface IViewAttachmentsDialogProps extends IDefaultDialogProps {
    attachments: string[];
}

interface IStateValues {
    attachmentInitialIndex: number;
}

const ViewAttachmentsDialog: React.FunctionComponent<IViewAttachmentsDialogProps> = ({
    open,
    handleClose,
    attachments
}) => {
    const { translate } = useLanguageContext();

    const fullscreenBackdrop = useBackdrop();

    const state = useState<IStateValues>({
        attachmentInitialIndex: 0
    });


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='close' onClick={handleClose} />
        ];
        // eslint-disable-next-line
    }, [translate]);


    return <>
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('attachments')}
            dialogActions={dialogActions}
            className='dialogactions-flexend overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid 
                container 
                columnSpacing={DefaultConstants.gridColumnSpacing} 
                rowSpacing={DefaultConstants.gridRowSpacing}
                paddingY={2}
            >
                {
                    attachments.length === 0 ? <>
                        <Grid item xs={12}>
                            <Empty text="noAttachmentsFound" />
                        </Grid>
                    </> : <>
                        {
                            attachments.map((a, index) => {
                                const name = a.split('/').pop()?.split('?')[0] ?? '';
                                
                                return <Grid item lg={4} sm={6} xs={6} key={index}>
                                    <AttachmentCard
                                        link={a}
                                        name={name}
                                        hoverAction="fullscreen"
                                        onClick={() => {
                                            state.update('attachmentInitialIndex', index);
                                            fullscreenBackdrop.handleOpen();
                                        }}
                                    />
                                </Grid>;
                            })
                        }
                    </>
                }
            </Grid>
        </Dialog>

        {
            attachments.length > 0 && <Backdrop open={fullscreenBackdrop.open} className='serviceorder-backdrop-attachment'>
                <IconButton 
                    className='backdrop-attachment-close' 
                    onClick={() => {
                        fullscreenBackdrop.handleClose();
                        state.update('attachmentInitialIndex', 0);
                    }}
                >
                    <Close fontSize='medium' />
                </IconButton>

                <Box className='backdrop-attachment-slider'>
                    <Slider
                        arrows={true}
                        dots={true}
                        properties={{
                            initial: state.values.attachmentInitialIndex,
                            perView: 1
                        }}
                        items={attachments.map((a, index) => {
                            if (FileHelper.IsImage(a)) {
                                return <img src={a} alt={`attachment_${index}`} key={index} className='backdrop-attachment-image' />;
                            }

                            return <video src={a} controls key={index} className='backdrop-attachment-video' />;
                        })}
                    />
                </Box>
            </Backdrop>
        }
    </>;
}

export default ViewAttachmentsDialog;